exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv[data-v-3054fba2] {\n\tposition: absolute;\n    width: 100%;\n    background: rgba(0, 0, 0, 0.7);\n    color: white;\n    padding: 0.5rem 1rem;\n    display: flex;\n    align-items: center;\n    z-index: 2;\n    font-size: 0.91rem;\n}\nspan[data-v-3054fba2] {\n\ttext-transform: initial;\n}\n", ""]);

// exports
